import { render, staticRenderFns } from "./Ledger.vue?vue&type=template&id=77dcd883&scoped=true&"
import script from "./Ledger.vue?vue&type=script&lang=js&"
export * from "./Ledger.vue?vue&type=script&lang=js&"
import style0 from "./Ledger.vue?vue&type=style&index=0&id=77dcd883&lang=scss&scoped=true&"
import style1 from "./Ledger.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dcd883",
  null
  
)

export default component.exports